/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Scan_Aim_HintInputs */

const vi_mobile_scan_aim_hint = /** @type {(inputs: Mobile_Scan_Aim_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đưa mã vạch vào trong khung`)
};

/**

* @param {Mobile_Scan_Aim_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const mobile_scan_aim_hint = /** @type {((inputs?: Mobile_Scan_Aim_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Scan_Aim_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_mobile_scan_aim_hint(inputs)
});